import type { ReactNode } from 'react';
import { ColorsEnum, Text } from './text';

interface IErrorMessageProps {
  className?: string;
  text?: ReactNode;
}

export const ErrorMessage = (props: IErrorMessageProps) => {
  if (!props.text) return null;
  return (
    <Text className={props.className} size='xs' color={ColorsEnum.Red}>
      {props.text}
    </Text>
  );
};
